import { shiftEditorViewState } from "..";
import { mutatorAction } from "satcheljs";

export default mutatorAction("updateMemberIdShift", function updateMemberIdShift(memberId: string) {
    if (shiftEditorViewState().shift) {
        shiftEditorViewState().shift.memberId = memberId;
    }
});